export default __webpack_public_path__ + "static/media/tick-standard.d06a7193.svg";